module.exports = __webpack_public_path__ + "img/cai4.a98f1bd4.png";